/**
 * /cima/voice client — TTS synthesis only for now (one-shot Polly).
 * Streaming endpoint is Phase 3.
 */
import { API_BASE, getApiHeaders } from './apiClient';
import type { SynthesiseResponse, TranscribeConfig } from '../types/voice';

export async function synthesise(text: string): Promise<SynthesiseResponse> {
  const res = await fetch(`${API_BASE}/cima/voice/synthesise`, {
    method:  'POST',
    headers: getApiHeaders(),
    body:    JSON.stringify({ text }),
  });
  const body = await res.text();
  const data = body ? JSON.parse(body) : {};
  if (!res.ok) throw new Error(data.error || `TTS HTTP ${res.status}`);
  return data;
}

/**
 * Fetch the Cognito Identity Pool config for browser-direct Transcribe
 * Streaming. The frontend uses these to mint short-lived AWS creds and
 * open a WebSocket directly to AWS Transcribe.
 */
export async function getTranscribeConfig(): Promise<TranscribeConfig> {
  const res = await fetch(`${API_BASE}/cima/voice/transcribe-config`, {
    method:  'GET',
    headers: getApiHeaders(),
  });
  const body = await res.text();
  const data = body ? JSON.parse(body) : {};
  if (!res.ok) throw new Error(data.error || `transcribe-config HTTP ${res.status}`);
  return data;
}
